import { I18n } from '@calendly/i18n'
import { ArrowChevronDownMiniIcon } from '@calendly/ui/components/icons'
import { useState } from 'react'

import { useGetUserQuery } from 'common'

import { ExternalInvitee } from './external_invitee/external_invitee'
import { ShowMoreButton } from './show_more_button'

const INVITEES_TO_SHOW = 5

export const ExternalEvent = ({ event }) => {
  const { data: currentUser } = useGetUserQuery()
  const { invitees, eventMemberships, ownerUserUuid } = event
  let attendees = invitees

  if (ownerUserUuid !== currentUser?.uuid) {
    attendees = eventMemberships.concat(attendees)
  }

  const [isExpanded, setExpanded] = useState(attendees.length <= INVITEES_TO_SHOW)
  const inviteesToShow = isExpanded ? attendees : attendees.slice(0, INVITEES_TO_SHOW)

  return (
    <div>
      {inviteesToShow.map((invitee) => (
        <ExternalInvitee key={invitee.email} invitee={invitee} />
      ))}
      {attendees.length > INVITEES_TO_SHOW && !isExpanded && (
        <ShowMoreButton event={event} expand={() => setExpanded(true)}>
          {String(I18n.t('publisher.meetings.invitees.view_more_guests', { count: attendees.length - INVITEES_TO_SHOW }))}
          <ArrowChevronDownMiniIcon />
        </ShowMoreButton>
      )}
    </div>
  )
}
